

import React, { useEffect } from 'react';
import { notification, Spin } from "antd";

import CompanyDetailSection from '../../shared/CompanyDetailSection';
import CustomerReviews from '../../shared/CustomerReviews';
import EnquireFormSection from '../../shared/EnquireFormSection';
import FeaturedCompaniesSection from '../../shared/FeaturedCompaniesSection';

const OrganizationDetail = (props) => {
  const { getFeaturedIndustries, getPeopleNeededForHelp, enquireQuery, followCompanyType, likeCompanyType, subscribe, shareCompany, getOrganization, getCustomerReviews, match, history, user, organizationDetails } = props;
  const { params } = match || {};
  const organizationId = params && params.id ? Number(params.id) : null;
  const { featuredOrganizations, numberOfPeople, customerReviews, organization, loading } = organizationDetails || {};
  const companyType = 'Organization';
  useEffect(() => {
    if (organizationId) {
      getPeopleNeededForHelp();
      getFeaturedIndustries(companyType);
      getOrganization(organizationId, user && user.id ? user.id : navigator.userAgent);
      getCustomerReviews();
    } else {
      notification.error({
        message: 'GET ORGANIZATION DETAILS',
        description: 'organizationId is not valid'
      })
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <Spin spinning={loading}>
        <section className="school-details-banner gen-banner-2">
          <div className="container">
            <div className="banner-text">
              <h1 className="heading"> </h1>
              <p></p>
            </div>
          </div>
        </section>

        <CompanyDetailSection 
          data={organization}
          numberOfPeople={numberOfPeople}
          companyType={companyType}
          subscribe={subscribe} 
          user={user}
          history={history}
          shareCompany={shareCompany}
          getIndustryDetails={getOrganization}
          getCompanyTypeListings={getOrganization}
          followCompanyType={followCompanyType}
          likeCompanyType={likeCompanyType} 
        />
        <CustomerReviews data={customerReviews} loading={loading} />
        <FeaturedCompaniesSection 
          data={featuredOrganizations}
          companyType={companyType}
        />
        <EnquireFormSection 
          enquireQuery={enquireQuery}
        />
      </Spin>
    </div>
  );
};

export default OrganizationDetail;
